module.exports = __webpack_public_path__ + "img/14.ff779344.png";